var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('h2',[_vm._v("MEMBERSHIP")]),_c('h4',[_vm._v("Refers to membership in HMI, pursuant to this Agreement.")])])
}]

export { render, staticRenderFns }